import React from "react";
import { Box, Button } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import Datepicker from "../../common/datePicker";
import DropDownOA from "../../common/dropDownOA";
import { Item } from "../../common/snippets";
import { itemsx } from "../../common/stylesInline/report_daily_branch";
import moment from "moment";
import { useAtomValue } from "jotai";
import { ChildCompanyListData } from "../../common/jotaiState/reportStateAtom";
import { CargoRoleRightsAtom } from "../../common/jotaiState/commonStateAtoms";
import * as sx from "../../common/stylesInline/report_daily_branch"

const FilterSection = ({
  branch,
  tripDate,
  branchList = [],
  branchDisabled = false,
  selectCompany,
  setSelectedCompany,
  onBranchChange,
  onDateChange,
  onLoadTrips,
}) => {
  const ChildCompanyList = useAtomValue(ChildCompanyListData)
  const roleRights = useAtomValue(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { DashboardAccessLevel } = RoleRights || {}
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: 2,
        mb: 0,
      }}
    >
      <Item sx={{ ...sx.itemsx }} className="dashboard-branch">
        <DropDownOA
          id=""
          label={'Select Company'}
          data={ChildCompanyList}
          width="100%"
          defaultvalue={selectCompany?.CompanyName || ''}
          dataKey={'CompanyName'}
          idKey={'CompanyID'}
          listWidth={'280px'}
          disabled={DashboardAccessLevel < 5}
          onSelect={setSelectedCompany}
        />
      </Item>
      <Item sx={itemsx} className="input--container bookingDatePicker">
        <DropDownOA
          id="branch"
          label="Select Branch"
          data={branchList}
          defaultvalue={branch?.BranchName || ""}
          idKey="BranchID"
          dataKey="BranchName"
          searchPlaceholder="Search Branch"
          onSelect={onBranchChange}
          width="260px"
          disabled={branchDisabled}
        />
      </Item>

      <Item sx={itemsx} className="input--container bookingDatePicker">
        <Datepicker
          id="tripDate"
          name="tripDate"
          label="Select Trip Date"
          value={tripDate}
          dateChange={onDateChange}
          dateDiff={365}
          width="210px"
          startDate={moment()}
          endDate={moment().add(3, "months")}
        />
      </Item>

      <Button
        variant="contained"
        startIcon={<LocalShippingIcon />}
        onClick={onLoadTrips}
        className="btn btn-primary margin-normal"
        sx={{
          height: "40px",
          minWidth: "140px",
          flexShrink: 0,
        }}
      >
        {"Load Trips"}
      </Button>
    </Box>
  );
};

export default FilterSection;